import React, { useEffect, useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";
import TimeLine from "../../common/components/TimeLine/TimeLine";
import RightSidebar from "../../common/components/RightSidebar/RightSidebar";
import SblcConfirm from "../../common/components/sblcComponent/SblcConfirm";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useGlobalState } from "../../common/GlobalProvider/GlobalStateProvider";
import JSZip from "jszip";
import * as FileSaver from "file-saver";
import PLPassword from "../../common/components/plPassword/PLPassword";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";

const Sblc = ({ islabel, setIsLabel }) => {
  const [isCount, setIsCount] = useState(2);
  const { setPageContent } = useGlobalState();
  // const retrievedData = JSON.parse(sessionStorage.getItem("formdata"));
  const retrievedData = useSelector((state) => state?.formdata);
  console.log("retrievedData", retrievedData);
  // useEffect(() => {
  //   setIsLabel(document.getElementById("sblc_Screen"));
  // },[islabel&&islabel]);

  // const handleDownload = () => {
  //   // Create and download PDF for Page 1
  //   // if (page1Canvas) {
  //   //   const doc1 = new jsPDF();
  //   //   const imgData1 = page1Canvas.toDataURL("image/png");
  //   //   doc1.addImage(imgData1, "PNG", 0, 0);
  //   //   doc1.save("page1.pdf");
  //   // }

  //   // Create and download PDF for Page 2
  //   const page2Element = document.getElementById("sblc_Screen")
  //   html2canvas(page2Element, { scale: 2 }).then((canvas) => {
  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF("p", "mm", "a4");
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();
  //     const imgWidth = pdfWidth;

  //     const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  //     pdf.addImage(imgData, "PNG", 0, 0, imgWidth, pdfHeight);
  //     pdf.save("sblc-confirm.pdf");
  //   });

  // };
  // useEffect(() => {
  //   const capturePage1 = async () => {
  //     const page1Element = document.getElementById('sblc_Screen');
  //     const canvas = await html2canvas(page1Element);
  //     setPage1Content(canvas.toDataURL('image/png'));
  //   };

  //   capturePage1();
  // }, [setPage1Content]);
  // useEffect(() => {
  //   const capturePage2 = async () => {
  //     const page1Element = document.getElementById("sblc_Screen");
  //     const canvas = await html2canvas(page1Element);
  //     setPageContent("page1Content", canvas.toDataURL("image/png"));
  //   };

  //   capturePage2();
  // }, [setPageContent]);

  const handleDownload = async () => {
    const page1Element = document.getElementById("sblc_Screen");
    const canvas = await html2canvas(page1Element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "pt", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("page1.pdf");
  };
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <div className="col-12  col-lg-2 p-0">
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className="col-12 col-md-12 col-lg-10">
            {/* Timeline Header */}
            <div className="row align-items-center">
              <div className="col-12 px-3 px-md-1 px-lg-1">
                <div className="headerTimeLine">
                  <TimeLine currentStep={isCount} />
                </div>
              </div>
            </div>

            {/* Main Body Section */}
            <div className="row px-3 px-md-4 px-lg-5 mt-2">
              {/* SBLC Section */}
              <div className="col-12 col-lg-9 d-flex justify-content-center align-items-start mb-4 mb-lg-0">
                <div className="statusWaiverMainContainer w-100">
                  <SblcConfirm />
                </div>
              </div>

              {/* Right Sidebar */}
              <div className="col-12 col-lg-3">
                <div className="right_sidebar">
                  <RightSidebar setIsCount={setIsCount} islabel="SBLC" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 p-0 col-md-3">
            <Sidebar />
          </div>

          <div className="col-sm-10 col-lg-10">
            <div className="row align-items-center">
              <div className="headerTimeLine px-5">
                <TimeLine currentStep={isCount} />
              </div>
            </div>
            <div className="row" style={{ paddingLeft: "3rem" }}>
              <div className="col-lg-9 p-0 m-0 d-flex align-items-center justify-content-center">
                <div className="statusWaiverMainContainer">
                  <div
                    id="sblc_Screen"
                    style={{
                      width: "794px",
                      minHeight: "1123px",
                      background: "white",
                    }}
                  >
                    <SblcConfirm />
                  </div>
                  <div className="d-flex justify-content-center py-5">
                    <button
                      className="summary-download-btn"
                      onClick={() => handleDownloadAll()}
                    >
                      {isProcessing ? "Loading...." : "Download"}
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 p-0 right_col">
                <div className="headerTimeLine_left">
                  <RightSidebar setIsCount={setIsCount} islabel={"SBLC"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <PLPassword />
    </>
  );
};

export default Sblc;
